import { render, staticRenderFns } from "./componentsTest.vue?vue&type=template&id=1468a0fc&scoped=true"
import script from "./componentsTest.vue?vue&type=script&lang=js"
export * from "./componentsTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1468a0fc",
  null
  
)

export default component.exports